module.exports = __webpack_public_path__ + "img/logo-white.3ca25ed5.svg";